if (!customElements.get("calorie-select")) {
  class ComponentCalorieSelect extends HTMLElement {
    constructor() {
      super();

      this.selectElement = this.querySelector('select');
      this.prev = this.querySelector('[data-prev]');
      this.current = this.querySelector('[data-current]');
      this.next = this.querySelector('[data-next]');

      this.prev.addEventListener("click", () => this.handlePrev());
      this.next.addEventListener("click", () => this.handleNext());

      this.changeEvent = new Event('change');

      this.init();
    }

    init() {
      this._updateCurrentText();
    }

    handlePrev() {
      if (this.selectElement.selectedIndex > 0) {
        this._changeOption(this.selectElement.selectedIndex - 1);
      }
    }

    handleNext() {
      const maxIndex = this.selectElement.options.length - 1;
      if (this.selectElement.selectedIndex < maxIndex) {
        this._changeOption(this.selectElement.selectedIndex + 1);
      }
    }

    _changeOption(newIndex) {
      this.selectElement.selectedIndex = newIndex;
      this._updateCurrentText();
      this.selectElement.dispatchEvent(this.changeEvent);
    }

    _updateCurrentText() {
      const selectedOption = this.selectElement.options[this.selectElement.selectedIndex];
      this.current.innerText = selectedOption.innerText;
    }
  }

  customElements.define("calorie-select", ComponentCalorieSelect);
}
